/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { blackMaterial, screenMaterial } from "../../../../common/materials";

const model = "/models/desk/screens.glb";

export default function Screens({ ...props }) {
  const group = useRef();
  const { nodes } = useGLTF(model);
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[-2, 1.46, 2.92]}>
        <mesh
          castShadow
          geometry={nodes.Plane004.geometry}
          material={blackMaterial}
        />
        <mesh geometry={nodes.Plane004_1.geometry} material={screenMaterial} />
      </group>
      <group position={[-2.71, 1.44, 2.82]}>
        <mesh
          castShadow
          geometry={nodes.Plane006.geometry}
          material={blackMaterial}
        />
        <mesh geometry={nodes.Plane006_1.geometry} material={screenMaterial} />
      </group>
    </group>
  );
}

useGLTF.preload(model);
